
/**
 * Module dependencies.
 */

import { Media, VideoSource } from '../../types';

/**
 * Export `resolveImageUrl`.
 */

export function resolveImageUrl(media: Media | null | undefined) {
  if (!media || media?.status === 'processing') {
    return null;
  }

  switch (media.type) {
    case 'image':
      return media.url;

    case 'video':
      return (media as VideoSource).previewUrl;

    default:
      throw new Error('Invalid media type');
  }
}
